import React from 'react';

const MyDocuments = () => {
  const documents = [
    { name: 'My Pictures', icon: '/pictures.ico', type: 'File Folder', modified: '8/20/2025 3:09 AM' },
    { name: 'My Music', icon: '/music.ico', type: 'File Folder', modified: '8/20/2025 3:09 AM' },
    { name: 'Sample Document.txt', icon: '/documents.ico', type: 'Text Document', modified: '8/19/2025 2:30 PM' },
    { name: 'Presentation.ppt', icon: '/documents.ico', type: 'Microsoft PowerPoint', modified: '8/18/2025 10:15 AM' }
  ];

  return (
    <div style={{ 
      padding: '8px', 
      fontSize: '11px', 
      fontFamily: 'Tahoma, sans-serif',
      height: '100%',
      overflow: 'auto'
    }}>
      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
          File and Folder Tasks
        </h3>
        <div style={{ 
          background: '#e6f3ff', 
          border: '1px solid #b3d9ff', 
          padding: '8px',
          borderRadius: '3px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ color: '#0066cc', cursor: 'pointer' }}>Make a new folder</div>
            <div style={{ color: '#0066cc', cursor: 'pointer' }}>Publish this folder to the Web</div>
            <div style={{ color: '#0066cc', cursor: 'pointer' }}>Share this folder</div>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
          Other Places
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>Desktop</div>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>Shared Documents</div>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>My Computer</div>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>My Network Places</div>
        </div>
      </div>

      <div>
        <div style={{ 
          borderBottom: '1px solid #ccc', 
          paddingBottom: '4px', 
          marginBottom: '8px',
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1.5fr 0.5fr',
          gap: '8px',
          fontWeight: 'bold',
          color: '#666'
        }}>
          <span>Name</span>
          <span>Type</span>
          <span>Date Modified</span>
          <span>Size</span>
        </div>
        
        <div>
          {documents.map((doc, index) => (
            <div key={index} style={{ 
              display: 'grid',
              gridTemplateColumns: '2fr 1fr 1.5fr 0.5fr',
              gap: '8px',
              padding: '4px 0',
              cursor: 'pointer',
              borderRadius: '2px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={doc.icon} alt={doc.name} style={{ width: '16px', height: '16px', marginRight: '6px' }} />
                <span>{doc.name}</span>
              </div>
              <span style={{ color: '#666' }}>{doc.type}</span>
              <span style={{ color: '#666' }}>{doc.modified}</span>
              <span style={{ color: '#666' }}>-</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyDocuments;
